import axios from 'axios'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import Moment from 'moment'
import { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { Link, useNavigate } from 'react-router-dom'
import '../styles/components/sidebar.css';
//import Calendar from '../Components/Calendar'
import Calendar from 'react-calendar'
import Indicador from '../Components/Dash/indicador'
import authService from '../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../Components/Main'
import SidebarMobile from '../Components/SideBar-right/SidebarMobile'
import '../styles/pages/home.css';
import ProfileDireita from '../Components/ProfileDireita'

function Home() {
  var user = authService.getCurrentUser()
  sessionStorage.visualizacao = 'Dashboard'
  let history = useNavigate()

  const dateAtual = new Date()
  if (sessionStorage.DataInicio === undefined) {
    sessionStorage.DataInicio = new Date(
      dateAtual.getFullYear(),
      dateAtual.getMonth(),
      1
    )
      .toISOString()
      .slice(0, 10)
    var x = new Date()
    sessionStorage.DataFim = x.toISOString().slice(0, 10)
    //sessionStorage.DataFim = new Date()
  }
  function handleUnidadeChange(event: any) {
    sessionStorage.IdUnidade = event.target.value
    sessionStorage.uniRazaoSocial =
      event.target.options[event.target.selectedIndex].text
    window.location.reload()
  }
  const [date, setDate] = useState([
    Moment(`${sessionStorage.DataInicio} 00:00:00`).isValid()
      ? new Date(`${sessionStorage.DataInicio} 00:00:00`)
      : new Date(sessionStorage.DataInicio),
    Moment(`${sessionStorage.DataFim} 23:59:59`).isValid()
      ? new Date(`${sessionStorage.DataFim} 23:59:59`)
      : new Date(sessionStorage.DataFim)
  ])
  const setSeacrhDate = (e: any) => {
    setDate(e)
    sessionStorage.DataInicio = e[0].toISOString().slice(0, 10)
    e[1].setDate(e[1].getDate() - 1)
    sessionStorage.DataFim = e[1].toISOString().slice(0, 10)
    window.location.reload()
  }
  function handleDashChange(event: any) {
    sessionStorage.visualizacao = event.target.value
    if(event.target.value === 'Dashboard'){
      history('/Home/')
    }
    else if (event.target.value === 'Listagem') {
      history('/ListagemHome')
    }
    else if (event.target.value === 'Checklist') {
      history('/ListagemChecklist')
    }
  }

  const [unidades, setUnidades] = useState<any[]>([])
  const [auditorias, setAuditorias] = useState<any[]>([])
  const [auditoriasGeral, setAuditoriasGeral] = useState<any[]>([])
  const [datasets, setdatasets] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [notaMin, setNotaMin] = useState(0)
  const [notaMax, setNotaMax] = useState(11)

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/unidadeUser/list/' +
          user[0].IdEmpresa +
          '/' +
          user[0].IdPessoa
      )
      .then(response => {
        setUnidades(response.data)
        if (sessionStorage.IdUnidade === undefined) {
          sessionStorage.IdUnidade = response.data[0].IdUnidade
          sessionStorage.uniRazaoSocial = response.data[0].uniRazaoSocial
          window.location.reload()
        }
      })
    if (sessionStorage.IdUnidade !== undefined) {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            '/api/v1/auditoria/list/' +
            user[0].IdEmpresa +
            '/' +
            sessionStorage.IdUnidade +
            '/' +
            sessionStorage.DataInicio +
            '/' +
            sessionStorage.DataFim
        )
        .then(response => {
          setAuditorias(response.data)
        })
    }
    if (sessionStorage.IdUnidade !== undefined) {
      axios
        .get(
          process.env.REACT_APP_API_URL +
            '/api/v1/auditoria/list/' +
            user[0].IdEmpresa +
            '/' +
            sessionStorage.IdUnidade
        )
        .then(response => {
          setAuditoriasGeral(response.data)
          setdatasets([
            {
              label: response.data[0].ano,
              data: [
                response.data[0].nota,
                response.data[1].nota,
                response.data[2].nota,
                response.data[3].nota,
                response.data[4].nota,
                response.data[5].nota,
                response.data[6].nota,
                response.data[7].nota,
                response.data[8].nota,
                response.data[9].nota,
                response.data[10].nota,
                response.data[11].nota
              ],
              backgroundColor: 'rgba(255, 99, 132, 0.5)'
            },
            {
              label: response.data[12].ano,
              data: [
                response.data[12].nota,
                response.data[13].nota,
                response.data[14].nota,
                response.data[15].nota,
                response.data[16].nota,
                response.data[17].nota,
                response.data[18].nota,
                response.data[19].nota,
                response.data[20].nota,
                response.data[21].nota,
                response.data[22].nota,
                response.data[23].nota
              ],
              backgroundColor: 'rgba(53, 162, 235, 0.5)'
            }
          ])
        })
    }
    if (sessionStorage.IdUnidade !== undefined) {
      //window.location.reload()
    }
  }, [])
  // useEffect(() => {
  //   axios
  //     .get(
  //       process.env.REACT_APP_API_URL +
  //       '/api/v1/auditoria/list/' +
  //       user[0].IdEmpresa +
  //       '/' +
  //       sessionStorage.IdUnidade
  //     )
  //     .then(response => {
  //       setAuditoriasGeral(response.data)
  //       setdatasets([
  //         {
  //           label: response.data[0].ano,
  //           data: [
  //             response.data[0].nota,
  //             response.data[1].nota,
  //             response.data[2].nota,
  //             response.data[3].nota,
  //             response.data[4].nota,
  //             response.data[5].nota,
  //             response.data[6].nota,
  //             response.data[7].nota,
  //             response.data[8].nota,
  //             response.data[9].nota,
  //             response.data[10].nota,
  //             response.data[11].nota
  //           ],
  //           backgroundColor: 'rgba(255, 99, 132, 0.5)'
  //         },
  //         {
  //           label: response.data[12].ano,
  //           data: [
  //             response.data[12].nota,
  //             response.data[13].nota,
  //             response.data[14].nota,
  //             response.data[15].nota,
  //             response.data[16].nota,
  //             response.data[17].nota,
  //             response.data[18].nota,
  //             response.data[19].nota,
  //             response.data[20].nota,
  //             response.data[21].nota,
  //             response.data[22].nota,
  //             response.data[23].nota
  //           ],
  //           backgroundColor: 'rgba(53, 162, 235, 0.5)'
  //         }
  //       ])
  //     })
  // }, [])

  // useEffect(() => {
  //   axios
  //     .get(
  //       process.env.REACT_APP_API_URL +
  //       '/api/v1/unidadeUser/list/' +
  //       user[0].IdEmpresa +
  //       '/' +
  //       user[0].IdPessoa
  //     )
  //     .then(response => {
  //       setUnidades(response.data)
  //       if (sessionStorage.IdUnidade === undefined) {
  //         sessionStorage.IdUnidade = response.data[0].IdUnidade
  //         sessionStorage.uniRazaoSocial = response.data[0].uniRazaoSocial
  //         window.location.reload()
  //       }
  //     })
  // }, [])

  const nota = auditorias.map(value => (value = parseFloat(value.audNota)))
  var soma = nota.reduce(function (soma, i) {
    return soma + i
  }, 0)

  const [notaGeral, setNotaGeral] = useState(0)

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const
      },
      title: {
        display: true,
        text: 'Comparativo geral'
      }
    }
  }
  const labels = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Set',
    'Out',
    'Nov',
    'Dez'
  ]
  const data = {
    labels,
    datasets: datasets
  }

  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>{sessionStorage.uniRazaoSocial}</TitlePage1>
            <TitlePage2>
              <label style={{ textTransform: 'capitalize', marginLeft: '5px', fontSize: '30px' }}>
              Auditorias de {/*{sessionStorage.DataInicio} - {sessionStorage.DataFim} - */}
              </label>
              <label style={{ textTransform: 'capitalize', marginLeft: '5px' }}>
                {date[0].toLocaleString('pt-br', { month: 'long' })}
                {
                  date[0].toLocaleString('pt-br', { month: 'long' }) 
                  !== 
                  date[1].toLocaleString('pt-br', { month: 'long' }) 
                  ? ' a ' + date[1].toLocaleString('pt-br', { month: 'long' }) : ''
                } 
                 
              </label>
            </TitlePage2>
          </TitleOfPage>

          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Filtrar Auditoria"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
          </div>
        </div>
        <div className="tabelaDashPadrao">
          <div className="classRest4">
            <div className="tableGraphContainer">
              <div className="tableGraphContainer2">
                <Bar options={options} data={data} />
              </div>
            </div>
          </div>
          <div
            className={`dashItem class-${
              Number((soma / nota.length).toFixed(2)) < 3
                ? 'red'
                : Number((soma / nota.length).toFixed(2)) < 6 &&
                  Number((soma / nota.length).toFixed(2)) >= 3
                ? 'orange'
                : Number((soma / nota.length).toFixed(2)) < 8 &&
                  Number((soma / nota.length).toFixed(2)) >= 6
                ? 'yellow'
                : 'green'
            }`}
          >
            <label className="linha1">Resultado Geral</label>
            <label className="linhaNota">
              {Number((soma / nota.length).toFixed(2))}
            </label>
            <div className="linha2">
              <div className="op1">
                <div className="op1-1">Mês Auditoria:</div>
                <div className="op1-1" style={{ textTransform: 'uppercase' }}>
                  {date[1].toLocaleString('pt-br', { month: 'long' })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cxLegendaRel">
          <label htmlFor="" className="lgHLegenda">
            Filtro:
          </label>
          <button
            className="lgHNeutro"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(0)
            }}
          >
            TODAS
          </button>
          <button
            className="lgHAcima"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(8)
            }}
          >
            BOM
          </button>
          <button
            className="lgHMedia"
            onClick={event => {
              setNotaMax(8)
              setNotaMin(6)
            }}
          >
            REGULAR
          </button>
          <button
            className="lgHOrange"
            onClick={event => {
              setNotaMax(6)
              setNotaMin(3)
            }}
          >
            RUIM
          </button>
          <button
            className="lgHAbaixo"
            onClick={event => {
              setNotaMax(3)
              setNotaMin(0)
            }}
          >
            INACEITÀVEL
          </button>
        </div>
        <div className="tabelaPadraoCad1">
          {auditorias
            .filter(val => {
              if (
                searchTerm === '' &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax
              ) {
                return val
              } else if (
                val.locDescricao
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax
              ) {
                return val
              }
            })
            .map(auditoria => (
              <a
                className="UniClienteMes"
                href={`http://cozinhaesaude.hitperformance.com.br/RelatorioAuditoria/${auditoria.audCodigoGUID}`}
                target={'_blank'}
                rel={'noreferrer'}
              >
                {/* <
                className="UniClienteMes"
                href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${auditoria.IdRetornoAuditoria}`}
                target={'_blank'}
                rel={'noreferrer'}
              > */}
                <Indicador
                  p_resultado={auditoria.audNota}
                  p_restaurante={auditoria.locDescricao}
                  p_data={auditoria.audFinalizadoEm}
                  p_cor={
                    parseInt(auditoria.audNota) < 3
                      ? 'red'
                      : parseInt(auditoria.audNota) < 6 &&
                        parseInt(auditoria.audNota) >= 3
                      ? 'orange'
                      : parseInt(auditoria.audNota) < 8 &&
                        parseInt(auditoria.audNota) >= 6
                      ? 'yellow'
                      : 'green'
                  }
                />
              </a>
            ))}
        </div>
      </ContainerPage>

      <nav className="esconderFiltro">
        <ProfileDireita />

        <div className="calendarRelatorio2">
          <form action="">
            <h1>Selecione:</h1>
            <label htmlFor="">Cliente/Unidade:</label>
            <select
              name="IdUnidade"
              onChange={event => {
                handleUnidadeChange(event)
              }}
            >
              {unidades.map(unidade => (
                <option
                  value={unidade.IdUnidade}
                  selected={
                    parseInt(unidade.IdUnidade) ===
                    parseInt(sessionStorage.IdUnidade)
                  }
                >
                  {unidade.uniRazaoSocial}
                </option>
              ))}
            </select>
            <label htmlFor="">Visualização:</label>
            <select
              name="tpDash"
              onChange={event => {
                handleDashChange(event)
              }}
            >
              <option
                value={'Dashboard'}
                // selected={'Dashboard' === sessionStorage.visualizacao}
              >
                Dashboard
              </option>
              <option
                value={'Listagem'}
                // selected={'Listagem' === sessionStorage.visualizacao}
              >
                Listagem
              </option>
              <option
                value={'Checklist'}
                // selected={'Listagem' === sessionStorage.visualizacao}
              >
                Checklist
              </option>
            </select>
            <label>Periodo Analisado:</label>

            <Calendar type="Hebrew" onChange={setSeacrhDate} value={date} selectRange={true} />
              
          </form>
        </div>
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default Home
